import { Component, Input } from '@angular/core';

@Component({
	// tslint:disable-next-line: component-selector
	selector: 'circular-progress',
	templateUrl: 'circular-progress.component.html',
	styleUrls: ['circular-progress.component.scss'],
})
export class CircularProgressComponent {
	@Input() progress;
	@Input() color = 'primary';
	@Input() size = 'small';
}
